/**
 * @group Components
 * 
 * @summary
 * <blockquote>Component for displaying onboarding blocked messages.</blockquote>
 * 
 * @example
 * ```tsx
 * <OnboardingBlockedMessage message={onboardingBlockedMessage} />
 * ```
 */

import type { OnboardingBlockedMessageProps } from './OnboardingBlockedMessageProps';

/**
 * Component for displaying onboarding blocked messages
 */
export function OnboardingBlockedMessage({ message }: OnboardingBlockedMessageProps) {
  if (!message) {
    return null;
  }

  return (
    <p className="mb-3 text-sm text-destructive">{message}</p>
  );
}
